import React, { useEffect, useState } from "react";

const LOADING_STEPS = [
  "Loading your live class schedule…",
  "Checking waitlists and open spots…",
  "Pulling website enrollment activity…",
  "Putting together your recommendations…",
];

const SkeletonLine = ({ width = "100%", tall }) => (
  <span
    className={`owner-dashboard__skeleton-line${
      tall ? " owner-dashboard__skeleton-line--tall" : ""
    }`}
    style={{ width }}
    aria-hidden="true"
  />
);

const DashboardLoading = () => {
  const [stepIndex, setStepIndex] = useState(0);

  useEffect(() => {
    const interval = window.setInterval(() => {
      setStepIndex((current) => (current + 1) % LOADING_STEPS.length);
    }, 2600);

    return () => window.clearInterval(interval);
  }, []);

  return (
    <div className="owner-dashboard__loading-screen" aria-busy="true">
      <div className="owner-dashboard__loading-status" role="status" aria-live="polite">
        <span className="owner-dashboard__loading-spinner" aria-hidden="true" />
        <p className="owner-dashboard__loading-message">{LOADING_STEPS[stepIndex]}</p>
        <p className="owner-dashboard__loading-hint">
          This usually takes a few seconds.
        </p>
      </div>

      <div className="owner-dashboard__skeleton-shell" aria-hidden="true">
        <div className="owner-dashboard__skeleton-sidebar">
          <SkeletonLine width="50%" />
          <span className="owner-dashboard__skeleton-nav-item" />
          <span className="owner-dashboard__skeleton-nav-item" />
          <span className="owner-dashboard__skeleton-nav-item" />
        </div>
        <div className="owner-dashboard__skeleton-main">
          <SkeletonLine width="35%" tall />
          <SkeletonLine width="70%" />
          <section className="owner-dashboard__panel owner-dashboard__skeleton-panel">
            <SkeletonLine width="60%" tall />
            <SkeletonLine width="90%" />
            <div className="owner-dashboard__skeleton-metrics">
              <span className="owner-dashboard__skeleton-tile" />
              <span className="owner-dashboard__skeleton-tile" />
              <span className="owner-dashboard__skeleton-tile" />
              <span className="owner-dashboard__skeleton-tile" />
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

export default DashboardLoading;
